import React from 'react';
import sidebarLogo from '../../../../assets/images/sidebar-image.jpg';
import DrawerListItem from "./drawer-list-item/DrawerListItem";
import drawerListItems from "./drawerListItems";
import {List, ListSubheader} from "@mui/material";

const DrawerList = () => {

    return (
        <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
                <ListSubheader component="div" style={{padding: '0'}}>
                    <img
                        style={{
                            height: "100%",
                            width: "100%",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.12"
                        }} src={sidebarLogo} alt='FastWeb Logo'/>
                </ListSubheader>
            }
            sx={{
                width: '100%',
                maxWidth: 360,
                backgroundColor: "transparent",
            }}
        >
            {drawerListItems.map((item, idx) => (
                <DrawerListItem key={`drawer-list-item-${idx}`}
                                text={item.text}
                                fontStyle="subtitle2"
                                to={item.to}
                                icon={item.icon}/>
            ))}
        </List>
    );
}


export default DrawerList;
